import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { NavLink } from "react-router-dom";
function PrincipalsMessage() {
    return (
        <>
            <Header />
            {/* Inner Slider */}
            <section class="inr-header">
                <div class="container">
                    <div class="inr-header-content">
                        <h1 class="title">Principal's Message</h1>
                        <ul class="breadcrumb">
                            <li><NavLink to="/">Home</NavLink></li>
                            <li> Principal's Message</li>
                        </ul>
                    </div>
                </div>
            </section>
            {/*  Inner Body */}
            <section className="innerBody">
                <div className="container them-container">
                    <div className="row">
                        <div className="col-12">
                            <h1>Principal's Message</h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 PrincipalDesk principal-message">
                            <img src="https://webapi.entab.info/api/image/SMNSB/public/images/principal.png" alt="Principal Photo" className="img-fluid" />

                            <p className="message-text"><strong> Welcome to St. Mary’s Nursery School, Bokaro</strong><br />
                                <i>"Education is not the mere acquisition of facts, but the cultivation of the mind and heart." – <br />Inspired by John Dewey</i>
                            </p>

                            <p>Dear Parents,<br />It is my pleasure to welcome you all at St. Mary’s Nursery School (SMNS) a place where learning meets love, curiosity meets creativity, and every child is encouraged to shine. Our motto, “Love One Another,” is the guiding light in every classroom, every activity, and every interaction. Here, children learn not only to excel academically but also to grow into compassionate, responsible, and confident individuals.</p>

                            <p>As Maria Montessori said, “Education is a natural process carried out by the child and is not acquired by listening to words but by experiences in the environment.” At SMNS, we ensure that our children are immersed in a nurturing environment that sparks curiosity, encourages exploration, and fosters empathy. Our focus is on holistic development academic, social, emotional, physical, and moral. So that each child emerges as a well-rounded citizen of the world.</p>

                            <p>A school is more than just a building; it is a community where young minds are inspired, talents are discovered, and values are nurtured. At SMNS, we combine state-of-the-art infrastructure, safe and stimulating surroundings, and an expertly trained faculty to provide experiences that shape character alongside knowledge. Through play-way learning, creative arts, collaborative projects, and personalized guidance, children are empowered to explore their potential and develop self-confidence, social skills, and moral insight.</p>

                            <p>We believe, as Lev Vygotsky emphasized, that learning is a social process. At SMNS, our classrooms are spaces of collaboration, dialogue, and friendship. Children are encouraged to respect diversity, practice empathy, and “love one another” the cornerstone of building a harmonious community.</p>

                            <p>Our vision is to create not just academically accomplished students, but thoughtful, sensitive, and joyful human beings who are prepared to face the world with courage, curiosity, and kindness. Every day at SMNS is dedicated to transforming the uncut diamonds into shining gems, instilling confidence, and fostering a lifelong love for learning.</p>

                            <p>We are committed to making your child’s journey with us a memorable, inspiring, and joyful experience, where education is meaningful, values are cherished, and childhood is celebrated. Together, as partners in your child’s growth, we will nurture not only intelligence but also character, for as Rabindranath Tagore said, “Intelligence plus character, that is the goal of true education.”</p>

                            <p>
                                <b>With warm regards,</b><br />
                                <b>Fr. Dinu M. Daniel</b><br />
                                <i>Principal, St. Mary’s Nursery School, Bokaro</i>
                            </p>
                            
                        </div>
                    </div>
                </div>
            </section>
            <div className="clr100"></div>
            {/* Footer */}
            <Footer />
        </>
    )
}

export default PrincipalsMessage